'use client'

import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { updateIndividualPrivacy } from '@/actions/updatePrivacySettings';

interface Props {
    userId: string;
    privacyKey: 'hideGoogle' | 'hideDiscord';
    initialValue: boolean;
}

export function IndividualPrivacyToggle({ userId, privacyKey, initialValue }: Props) {
    const [isHidden, setIsHidden] = useState(initialValue);
    const [isLoading, setIsLoading] = useState(false);

    const handleToggle = async () => {
        setIsLoading(true);
        const nextValue = !isHidden;
        await updateIndividualPrivacy(userId, privacyKey, nextValue);
        setIsHidden(nextValue);
        setIsLoading(false);
    };

    return (
        <button 
            onClick={handleToggle}
            disabled={isLoading}
            className={`p-1 rounded transition-colors ${isHidden ? 'text-slate-300 hover:text-amber-600' : 'text-amber-700 hover:text-amber-900'}`}
            title={isHidden ? "Currently Hidden" : "Currently Public"}
        >
            {isHidden ? <EyeOff size={14} /> : <Eye size={14} />}
        </button>
    );
}